module.exports = __webpack_public_path__ + "img/amanda.632373b6.jpg";